// extracted by mini-css-extract-plugin
module.exports = {"o-voyage-activity":"VoyageActivity_o-voyage-activity__1VbCI"};